import { useMemo } from 'react'

import { Text } from '@wartek-id/text-v1'

import { resolvePerencanaanReviewDiff } from 'app/KinerjaGuruPage/utils/perencanaan'
import { IndikatorPerencanaanPanel } from 'app/KinerjaShared/components/IndikatorPerencanaanPanel'
import { PerencanaanReviewDiff } from 'app/KinerjaShared/components/PerencanaanReviewDiff'

import type { PerencanaanItemReviewDiff } from 'app/KinerjaGuruPage/types/perencanaan'
import type { KinerjaUtamaDetail } from 'types/kinerja'

export type PengembanganKompetensiItemProps = {
  originalId: number
  reviewId: number
  showReview: boolean
  contents: Array<KinerjaUtamaDetail>
  orderNumber: number
}

/** @deprecated use `PerencanaanPengembanganKompetensiItem` from `app/KinerjaShared/components/PerencanaanPengembanganKompetensiItem` instead. */
export function PengembanganKompetensiItem({
  originalId,
  reviewId,
  showReview,
  contents,
  orderNumber,
}: PengembanganKompetensiItemProps) {
  // Content as map for constant time lookup
  const contentsMap: Record<number, KinerjaUtamaDetail> = useMemo(() => {
    return contents.reduce((acc, content) => {
      acc[content.id] = content
      return acc
    }, {} as Record<number, KinerjaUtamaDetail>)
  }, [contents])

  // Resolved items
  const resolvedItem: PerencanaanItemReviewDiff<string> = useMemo(() => {
    let item: PerencanaanItemReviewDiff<number> = null

    if (showReview) {
      item = resolvePerencanaanReviewDiff([originalId], [reviewId])[0]
    } else {
      item = {
        isChanged: false,
        original: originalId,
        review: null,
      }
    }

    // Map to content
    const mappedItem: PerencanaanItemReviewDiff<string> = {
      original: null,
      review: null,
      isChanged: item.isChanged,
    }

    if (item.original) {
      mappedItem.original = contentsMap[item.original]?.rencanaHasilKerja
    }

    if (item.review) {
      mappedItem.review = contentsMap[item.review]?.rencanaHasilKerja
    }

    return mappedItem
  }, [originalId, reviewId, contentsMap, showReview])

  const shouldShowReview = showReview && resolvedItem.isChanged

  return (
    <IndikatorPerencanaanPanel
      variant="static"
      orderNumber={orderNumber}
      upperContent={
        shouldShowReview && (
          <PerencanaanReviewDiff
            originalLabel="Perencanaan Guru"
            reviewLabel="Penyesuaian dari Kepala Sekolah"
            originalContent={
              <IndikatorPerencanaanPanel
                variant="static"
                orderNumber={orderNumber}
              >
                <Text>
                  Terlaksananya pengembangan kompetensi yang meningkatkan
                  pembelajaran yang bermutu untuk semua berdasarkan indikator
                  &nbsp;
                  <strong>{resolvedItem.original}</strong>
                </Text>
              </IndikatorPerencanaanPanel>
            }
            reviewContent={
              <IndikatorPerencanaanPanel
                variant="static"
                orderNumber={orderNumber}
              >
                <Text>
                  Terlaksananya pengembangan kompetensi yang meningkatkan
                  pembelajaran yang bermutu untuk semua berdasarkan indikator
                  &nbsp;
                  <strong>{resolvedItem.review}</strong>
                </Text>
              </IndikatorPerencanaanPanel>
            }
          />
        )
      }
    >
      <Text>
        Terlaksananya pengembangan kompetensi yang meningkatkan pembelajaran
        yang bermutu untuk semua berdasarkan indikator&nbsp;
        <strong>
          {shouldShowReview ? resolvedItem.review : resolvedItem.original}
        </strong>
      </Text>
    </IndikatorPerencanaanPanel>
  )
}
